"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestDataIntegration = void 0;

var _integration = require("../integration.js");

var _requestdata = require("../utils-hoist/requestdata.js");

const _excluded = ["ip", "user"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const DEFAULT_OPTIONS = {
  include: {
    cookies: true,
    data: true,
    headers: true,
    ip: false,
    query_string: true,
    url: true,
    user: {
      id: true,
      username: true,
      email: true
    }
  },
  transactionNamingScheme: 'methodPath'
};
const INTEGRATION_NAME = 'RequestData';

const _requestDataIntegration = (options = {}) => {
  const _options = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options), {}, {
    include: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS.include), options.include), {}, {
      user: options.include && typeof options.include.user === 'boolean' ? options.include.user : _objectSpread(_objectSpread({}, DEFAULT_OPTIONS.include.user), (options.include || {}).user)
    })
  });

  return {
    name: INTEGRATION_NAME,

    processEvent(event) {
      // Note: In the long run, most of the logic here should probably move into the request data utility functions. For
      // the moment it lives here, though, until https://github.com/getsentry/sentry-javascript/issues/5718 is addressed.
      // (TL;DR: Those functions touch many parts of the repo in many different ways, and need to be cleaned up. Once
      // that's happened, it will be easier to add this logic in without worrying about unexpected side effects.)
      const _event$sdkProcessingM = event.sdkProcessingMetadata,
            sdkProcessingMetadata = _event$sdkProcessingM === void 0 ? {} : _event$sdkProcessingM;
      const request = sdkProcessingMetadata.request,
            normalizedRequest = sdkProcessingMetadata.normalizedRequest;
      const addRequestDataOptions = convertReqDataIntegrationOptsToAddReqDataOpts(_options); // If this is set, it takes precedence over the plain request object

      if (normalizedRequest) {
        // Some other data is not available in standard HTTP requests, but can sometimes be augmented by e.g. Express or Next.js
        const ipAddress = request ? request.ip || request.socket && request.socket.remoteAddress : undefined;
        const user = request ? request.user : undefined;
        (0, _requestdata.addNormalizedRequestDataToEvent)(event, normalizedRequest, {
          ipAddress,
          user
        }, addRequestDataOptions);
        return event;
      } // TODO(v9): Eventually we can remove this fallback branch and only rely on the normalizedRequest above


      if (!request) {
        return event;
      } // eslint-disable-next-line deprecation/deprecation


      return (0, _requestdata.addRequestDataToEvent)(event, request, addRequestDataOptions);
    }

  };
};
/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/core`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 */


const requestDataIntegration = exports.requestDataIntegration = (0, _integration.defineIntegration)(_requestDataIntegration);
/** Convert this integration's options to match what `addRequestDataToEvent` expects */

/** TODO: Can possibly be deleted once https://github.com/getsentry/sentry-javascript/issues/5718 is fixed */

function convertReqDataIntegrationOptsToAddReqDataOpts(integrationOptions) {
  const transactionNamingScheme = integrationOptions.transactionNamingScheme,
        _integrationOptions$i = integrationOptions.include,
        ip = _integrationOptions$i.ip,
        user = _integrationOptions$i.user,
        requestOptions = _objectWithoutProperties(_integrationOptions$i, _excluded);

  const requestIncludeKeys = ['method'];

  for (const _ref of Object.entries(requestOptions)) {
    var _ref2 = _slicedToArray(_ref, 2);

    const key = _ref2[0];
    const value = _ref2[1];

    if (value) {
      requestIncludeKeys.push(key);
    }
  }

  let addReqDataUserOpt;

  if (user === undefined) {
    addReqDataUserOpt = true;
  } else if (typeof user === 'boolean') {
    addReqDataUserOpt = user;
  } else {
    const userIncludeKeys = [];

    for (const _ref3 of Object.entries(user)) {
      var _ref4 = _slicedToArray(_ref3, 2);

      const key = _ref4[0];
      const value = _ref4[1];

      if (value) {
        userIncludeKeys.push(key);
      }
    }

    addReqDataUserOpt = userIncludeKeys;
  }

  return {
    include: {
      ip,
      user: addReqDataUserOpt,
      request: requestIncludeKeys.length !== 0 ? requestIncludeKeys : undefined,
      transaction: transactionNamingScheme
    }
  };
}